import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, Phone, ShieldCheck, ShoppingBag, Wrench } from 'lucide-react';

export function CTASection() {
  return (
    <section className="py-28 bg-white">
      <div className="home-shell">
        <motion.div
          initial={{ opacity: 0, y: 26 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.65 }}
          className="relative overflow-hidden rounded-[2.4rem] bg-[linear-gradient(135deg,#111111_0%,#161616_50%,#18392b_100%)] text-white shadow-[0_30px_100px_rgba(0,0,0,0.16)]"
        >
          <div className="absolute inset-0 pointer-events-none">
            <div className="absolute top-0 left-0 h-72 w-72 rounded-full bg-white/6 blur-3xl" />
            <div className="absolute bottom-0 right-0 h-72 w-72 rounded-full bg-[#f4d7a2]/10 blur-3xl" />
          </div>

          <div className="relative z-10 grid gap-10 p-8 md:p-12 lg:grid-cols-[minmax(0,1.08fr)_minmax(300px,0.92fr)] lg:items-end lg:gap-12 lg:p-16">
            <div className="lg:pr-4">
              <span className="inline-flex rounded-full border border-white/10 bg-white/5 px-4 py-1.5 text-xs font-semibold uppercase tracking-[0.18em] text-white/65 mb-6">
                Listo para empezar
              </span>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-[0.98] tracking-tight mb-6">
                Encuentra tu Zwheel y todo lo que necesitas en un solo lugar
              </h2>
              <p className="text-lg md:text-xl text-white/72 leading-relaxed mb-10 max-w-2xl">
                Compara modelos, encuentra accesorios y recambios compatibles y accede al soporte oficial desde una experiencia simple y bien guiada.
              </p>

              <div className="flex flex-col sm:flex-row gap-3 mb-8">
                <Link
                  to="/patinetes-electricos"
                  className="inline-flex items-center justify-center rounded-full bg-white px-6 py-3.5 text-sm font-semibold text-black transition-all duration-300 hover:bg-[#f3eadc]"
                >
                  Explorar patinetes
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Link>
                <Link
                  to="/contacto"
                  className="inline-flex items-center justify-center rounded-full border border-white/18 bg-white/6 px-6 py-3.5 text-sm font-semibold text-white backdrop-blur-sm transition-all duration-300 hover:bg-white/12"
                >
                  <Phone className="w-4 h-4 mr-2" />
                  Hablar con el equipo
                </Link>
              </div>

              <div className="flex flex-wrap gap-6 text-sm text-white/58 uppercase tracking-[0.16em]">
                <span>Compra guiada</span>
                <span>Soporte oficial</span>
                <span>Accesorios y recambios</span>
              </div>
            </div>

            <div className="w-full max-w-[28rem] lg:justify-self-end">
              <div className="rounded-[2rem] border border-white/10 bg-white/7 p-6 backdrop-blur-sm shadow-[0_24px_80px_rgba(0,0,0,0.16)]">
                <p className="text-xs font-semibold uppercase tracking-[0.18em] text-white/55 mb-5">
                  Ruta Zwheel
                </p>

                <div className="space-y-3">
                  <div className="flex items-start gap-4 rounded-[1.4rem] border border-white/8 bg-black/16 px-4 py-4">
                    <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white/10 text-white">
                      <ShoppingBag className="h-5 w-5" />
                    </div>
                    <div>
                      <h3 className="text-base font-semibold text-white mb-1">Gama de patinetes</h3>
                      <p className="text-sm leading-relaxed text-white/64">
                        Compara lineas, entra al detalle de cada modelo y elige con mas claridad.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4 rounded-[1.4rem] border border-white/8 bg-black/16 px-4 py-4">
                    <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white/10 text-white">
                      <Wrench className="h-5 w-5" />
                    </div>
                    <div>
                      <h3 className="text-base font-semibold text-white mb-1">Accesorios y recambios</h3>
                      <p className="text-sm leading-relaxed text-white/64">
                        Encuentra piezas compatibles y complementos para cada familia de producto.
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4 rounded-[1.4rem] border border-white/8 bg-black/16 px-4 py-4">
                    <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-white/10 text-white">
                      <ShieldCheck className="h-5 w-5" />
                    </div>
                    <div>
                      <h3 className="text-base font-semibold text-white mb-1">Soporte oficial</h3>
                      <p className="text-sm leading-relaxed text-white/64">
                        Contacto, mantenimiento y ayuda posventa organizados dentro del mismo sitio.
                      </p>
                    </div>
                  </div>
                </div>

                <Link
                  to="/accesorios-recambios"
                  className="mt-6 inline-flex items-center text-sm font-semibold text-white transition-colors duration-300 hover:text-[#f4d7a2]"
                >
                  Ver accesorios y recambios
                  <ArrowRight className="ml-2 h-4 w-4" />
                </Link>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
